export default {
  isLoading: false,
  isModalLoading: false,
}
